<template>
  <v-dialog v-model="dialog" persistent width="700">
    <v-card>
      {{this.$data.form}}
      <v-form ref="form" v-model="valid" @submit.prevent="save()">
        <v-card-title class="headline">
          <v-icon>edit</v-icon> Editar detalle
          <v-spacer></v-spacer>
          <v-btn icon @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex md6>
                <v-text-field
                  type="date"
                  v-model="form.fecha_desde"
                  label="Fecha salida"
                  :rules="$validate(['required'])"
                  @input="() => (form.fecha_hasta = form.fecha_desde)"
                  required
                />

              </v-flex> 
              <v-flex md6 v-if="this.id !=87 && this.id !=14">
                <v-text-field
                  type="date"
                  v-model="form.fecha_hasta"
                  label="Fecha hasta"
                  :rules="$validate(['required'])"
                  required
                  
                />
              </v-flex>
              <v-flex md6 v-if="this.id !=14">
                <v-text-field
                  type="time"
                  label="Hora desde"
                  :rules="$validate(['required'])"
                  required
                  v-model="form.hora_desde"
                />
              </v-flex>
              <v-flex md6>
                <v-text-field
                  type="time"
                  label="Hora hasta"
                  :rules="$validate(['required'])"
                  required
                  v-model="form.hora_hasta"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          
          <v-btn color="success" @click="save()">
            <v-icon>save</v-icon>
            Guardar
          </v-btn>
          <v-btn color="error" @click="close()">
            <v-icon>clear</v-icon>
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";

export default {
  mixins: [validate],
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      backup:{},
      id:0,
      edit:true
      
      
    };
  },
  mounted() {
    this.$bus.$on("editarDetalle", (item, id) => {
     this.id=id;
     console.log("ID ",this.id);
      const temp = {
        fecha_desde: item.fecha_desde,
        fecha_hasta: item.fecha_hasta,
        hora_desde: item.hora_desde,
        hora_hasta: item.hora_hasta,
        motivo: item.motivo,
      };
      this.backup = temp;
      this.form = item;
      this.dialog = true;
      
    });
  },
  methods: {
    close() {
      this.dialog = false;
      this.form.hora_desde =this.backup.hora_desde;
      this.form.hora_hasta=this.backup.hora_hasta;
      this.form.fecha_desde= this.backup.fecha_desde;
      this.form.fecha_hasta=this.backup.fecha_hasta;
      this.edit = false
      this.$bus.$emit("closeDialog");
    },
    
    /* save(){
      this.form.h
        this.edit = true
        this.$message.success();
        this.loading = false;
        this.close();
    },
 */
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/permiso/dialogs/EditarPermisoDetalle.vue